import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "table card-table" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Id"),
    /*#__PURE__*/_createElementVNode("th", null, "Registry Key"),
    /*#__PURE__*/_createElementVNode("th", null, "Invoice Key"),
    /*#__PURE__*/_createElementVNode("th", null, "Payment Method Id"),
    /*#__PURE__*/_createElementVNode("th", null, "Item Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1)
const _hoisted_3 = { class: "table-border-bottom-0" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  class: "modal fade",
  id: "staticBackdrop",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_7 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_8 = { class: "modal-content" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, "Confirm to Delete"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_10 = { class: "modal-body" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Are You Sure want to delete this ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Page")
const _hoisted_13 = { class: "modal-footer" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal",
  id: "myCloseButton"
}, "Close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("tbody", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions, (post) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: post.id
          }, [
            _createElementVNode("td", null, _toDisplayString(post.id), 1),
            _createElementVNode("td", null, _toDisplayString(post.registry_key), 1),
            _createElementVNode("td", null, _toDisplayString(post.invoice_key), 1),
            _createElementVNode("td", null, _toDisplayString(post.payment_method_setting_id), 1),
            _createElementVNode("td", null, _toDisplayString(post.item_name), 1),
            _createElementVNode("td", null, _toDisplayString(post.amount), 1),
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                type: "button",
                class: "me-2 btn btn-warning",
                onClick: ($event: any) => (_ctx.sendData(post.id.toString()))
              }, " Edit ", 8, _hoisted_4),
              _createElementVNode("button", {
                type: "button",
                class: "me-2 btn btn-danger",
                "data-bs-toggle": "modal",
                "data-bs-target": "#staticBackdrop",
                onClick: ($event: any) => (_ctx.deleteclick(post.id, post.title))
              }, " Delete ", 8, _hoisted_5)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", null, [
              _hoisted_11,
              _createElementVNode("strong", null, _toDisplayString(_ctx.deletevalue.title), 1),
              _hoisted_12
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteItem(_ctx.deletevalue.id)))
            }, "Delete")
          ])
        ])
      ])
    ])
  ]))
}